/**
 * User store module. Only add User related functions and data here
 *
 * @module store/user-login/state
 */
export const state = () => ({
  user: {},
  Email: null,
  Language: null,
  theme: {
    style: null,
    logo: null,
    isApplied: true
  },
  platformNotificationsList: null,
  quicklinks: []
});
